module.exports = __webpack_public_path__ + "img/diwei.25af99f5.png";